import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { M } from '@dashboard-experience/mastodon';
import styled from 'styled-components';
import Panel from '../../../Panels';
import { FmcsaPreEmploymentScreeningObject } from '../../../../types/report';

interface FmcsaPreEmploymentScreeningProgramProps {
  search: FmcsaPreEmploymentScreeningObject;
}

const ResultBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 12px;
  border-radius: 1rem;
  font-size: 13px;
  font-weight: 500;
  background-color: #f2f5f7;
  color: #334559;
  border: 1px solid #e1e6eb;
`;

const PdfLink = styled.a`
  color: #1a73e8;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const FmcsaPreEmploymentScreeningProgram = ({
  search,
}: FmcsaPreEmploymentScreeningProgramProps) => (
  <Panel
    data-testid='fmcsa-pre-employment-screening-program'
    title={i18n.getStr('components.fmcsaPreEmploymentScreeningProgram.title')}
    status={search.status}
  >
    {search.status === 'complete' && search.recordResult && (
      <M.Grid>
        <M.GridRow className='mt-4 md-4 mb-2'>
          <M.GridCol md={3} className='text-very-muted mb-3 mb-md-0 pl-5'>
            {i18n.getStr(
              'components.fmcsaPreEmploymentScreeningProgram.recordResult',
            )}
          </M.GridCol>
          <M.GridCol md={9} className='mb-3 mb-md-0'>
            <ResultBadge>
              {search.recordResult.toUpperCase() === 'FOUND'
                ? i18n.getStr(
                    'components.fmcsaPreEmploymentScreeningProgram.found',
                  )
                : i18n.getStr(
                    'components.fmcsaPreEmploymentScreeningProgram.notFound',
                  )}
            </ResultBadge>
          </M.GridCol>
        </M.GridRow>
        {search.recordResult.toUpperCase() === 'FOUND' && search.pdfUrl && (
          <M.GridRow className='mt-2 mb-2'>
            <M.GridCol md={3} className='text-very-muted mb-3 mb-md-0 pl-5'>
              {i18n.getStr(
                'components.fmcsaPreEmploymentScreeningProgram.resultDetails',
              )}
            </M.GridCol>
            <M.GridCol md={9} className='mb-3 mb-md-0'>
              <PdfLink
                href={search.pdfUrl}
                target='_blank'
                rel='noopener noreferrer'
                data-testid='fmcsa-pre-employment-screening-program-pdf-link'
              >
                psp_report.pdf
              </PdfLink>
            </M.GridCol>
          </M.GridRow>
        )}
      </M.Grid>
    )}
  </Panel>
);

export default FmcsaPreEmploymentScreeningProgram;
